/**
 * `src/cards` public surface. Owner: Cards — P8 (rules engine `rules/`, AI, collection, decks, screens) and P9
 * (`snails/`). Rewards are `CardFact`s passed to `ctx.services.rewards.grant()` (BUILD-PLAN §0 rule 7).
 */
import type { FeatureModule } from '../shared';
import { cardsSlice, readCards } from './save';
import { cardsScreens } from './screens';
import { CARD_POOL } from '../content/cards/catalog';

export const cards: FeatureModule = {
  key: 'cards',
  slices: [cardsSlice],
  screens: cardsScreens,
  onBoot: ctx => {
    ctx.services.cards = {
      addCards: (ids, reason) => ctx.store.update('cards', raw => {
        const s = readCards(raw);
        for (const id of ids) {
          if (!CARD_POOL.some(c => c.id === id)) continue;
          if (!s.owned.includes(id)) s.owned.push(id); else s.ink++;
        }
        Object.assign(raw, s);
      }, reason),
    };
  },
  debugApi: () => ({ cards: {}, snails: {}, dice: {} }),
};

export { cardsSlice, type CardsSave } from './save';
